import Header from "../header"
import ServiceCards from "../servicecard";
import TaskBar from "../taskbar";
import CopyRight from "../copyright";


const Services = () => {

    return (
        <>
        <Header />
        <ServiceCards />
        <TaskBar />
        <CopyRight />
        </>
    )
}

export default Services